// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X03W","footer":"styles_footer__VrwbW"};